import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WorksShiftsApi from '@/services/apiServiceModules/worksShiftsApi.js'
const worksShiftsApi = new WorksShiftsApi()

export default class WorksShiftsDt extends DataTransferModule {
  constructor() {
    super(ModulesMap.WORKS_SHIFT, worksShiftsApi, {
      useCache: true,
    })
  }
}
